module.exports = __webpack_public_path__ + "img/photo-20.8822c41e.webp";